<template>
  <div class="container">
    <page-header
      title="Manifest"
      breadcrumb="Dashboard > Bookings & Shipments > Dispatch Management > Manifest"
      :back="{ name: 'Dispatch' }"
    />
    <div class="card">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="shipping">Shipping Ref.</label>
            <base-input id="shipping" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="fleet">Fleet ID</label>
            <base-input id="fleet" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="Shipper">Shipper</label>
            <base-input id="Shipper" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="Consignee">Consignee</label>
            <base-input id="Consignee" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="startDate">Start Date</label>
            <el-date-picker
              v-model="startDate"
              type="datetime"
              placeholder="Select Start date and time"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="startDate">End Date</label>
            <el-date-picker
              v-model="endDate"
              type="datetime"
              placeholder="Select End date and time"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="Official">Name of Official</label>
            <base-input id="Official" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="role">Role of Official</label>
            <base-input id="role" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="status">Current Status</label>
            <base-input id="status" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="status">Comments</label>
            <textarea
              class="input"
              style="height: auto"
              name=""
              id=""
              cols="30"
              rows="5"
            ></textarea>
          </div>
        </div>
        <div class="col-md-6">
          <h3 class="label text-md flex gap-2">
            <span>
              <svg
                width="20"
                height="24"
                viewBox="0 0 20 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.5551 2.89598C19.3147 2.77012 19.0177 2.77012 18.7774 2.89598C17.8467 3.3623 16.7981 3.60478 15.733 3.6C14.1762 3.63098 12.6709 3.09773 11.5553 2.12002C10.2674 0.985406 8.5261 0.365438 6.72431 0.400031C5.27324 0.388734 3.85452 0.785906 2.66662 1.53605V1.2C2.66662 0.537281 2.0697 0 1.33331 0C0.596917 0 0 0.537234 0 1.2V22.8C0 23.4627 0.596917 24 1.33331 24C2.06965 24 2.66662 23.4628 2.66662 22.8V12.4C2.81391 12.3876 2.95422 12.3376 3.07104 12.256C4.12842 11.5552 5.41126 11.1844 6.72431 11.2C8.28397 11.1677 9.79254 11.701 10.9109 12.68C12.1963 13.8129 13.9342 14.4328 15.7331 14.4C17.1116 14.4144 18.4638 14.0594 19.6174 13.38C19.8643 13.226 20.0081 12.9702 19.9996 12.6999V3.6C20.0041 3.31022 19.834 3.04087 19.5551 2.89598ZM1.77768 22.8C1.77768 23.0209 1.57872 23.2 1.33326 23.2C1.08779 23.2 0.888839 23.0209 0.888839 22.8V1.2C0.888839 0.979078 1.08779 0.800016 1.33326 0.800016C1.57872 0.800016 1.77768 0.979078 1.77768 1.2V22.8ZM19.1107 12.716C18.1045 13.3005 16.9305 13.6078 15.733 13.6C14.1762 13.631 12.6709 13.0978 11.5553 12.12C10.2674 10.9854 8.5261 10.3655 6.72431 10.4001C5.27418 10.3861 3.85545 10.7805 2.66662 11.5281V2.568C3.7766 1.66406 5.22767 1.17488 6.72431 1.2C8.28397 1.16775 9.79254 1.70105 10.9109 2.67998C12.1963 3.81295 13.9342 4.43283 15.7331 4.39997C16.91 4.40737 18.0706 4.15172 19.1108 3.65597V12.716H19.1107Z"
                  fill="#10233E"
                />
              </svg>
            </span>
            visibility Flag
            <tool-tip text="Choose who can view updates" />
          </h3>

          <div class="flex gap-4 mt-3 mb-4">
            <label class="radio-label" for="all">
              <input type="radio" id="all" value="all" v-model="visibility" />
              All
              <span></span>
            </label>
            <label class="radio-label" for="Users">
              <input
                type="radio"
                id="Users"
                value="Users"
                v-model="visibility"
              />
              Users
              <span></span>
            </label>
            <label class="radio-label" for="Customers">
              <input
                type="radio"
                id="Customers"
                value="Customers"
                v-model="visibility"
              />
              Customers
              <span></span>
            </label>
          </div>
        </div>
      </div>
      <div class="flex justify-end">
          <base-button text="Update" />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";

export default {
  components: {
    PageHeader,
  },
  data() {
    return {
      shipper: {
        customerType: "",
      },
      startDate: "",
      endDate: "",
      visibility: "",
    };
  },
};
</script>

<style>
</style>